import { safeLocalStorage } from '@toss/storage';

import { AI_GENERATE_DOCK_ONBOARDING_STORAGE_KEY } from '../consts/aiGenerateDockOnboarding.const';

/**
 * 생성기 코치마크를 이미 봤는지 — 끝까지 봤든 중간에 걷어 냈든 다시 띄우지 않는다.
 * 브라우저별이다. 같은 기기를 여러 선생님이 쓰는 경우는 드물고, 서버에 둘 만한 값이 아니다
 * (play 「내 보드」 코치마크와 같은 판단).
 */
export const aiGenerateDockOnboardingStorage = {
  hasSeen: () =>
    safeLocalStorage.get(AI_GENERATE_DOCK_ONBOARDING_STORAGE_KEY) !== null,
  markSeen: () =>
    safeLocalStorage.set(AI_GENERATE_DOCK_ONBOARDING_STORAGE_KEY, '1'),
};
